import React from "react";
import DefaultModal from "./DefaultModal";
import DangerModal from "./DangerModal";
import { useModal } from "hooks/Modal";
import ModalRoot from "./ModalRoot";

export default function Modal() {
    const { state } = useModal();

    let modal = null;
    switch (state.variant) {
        case "danger":
            modal = <DangerModal />;
            break;
        default:
            modal = <DefaultModal />;
    }

    return <ModalRoot>{modal}</ModalRoot>;
}
